<template>
  <v-container id="detailsContainer">
    <v-layout row wrap align-center my-5>
      <v-flex xs8 sm6 md4 mx-auto>
        <img src="../../assets/undraw_game_day.svg" alt="Fans" class="image" />
      </v-flex>
      <v-flex xs10 sm6 md8 mx-auto>
        <p class="display-1 font-weight-regular mt-3 mx-5 text-xs-center">
          Compete with your friends
        </p>
      </v-flex>
      <v-flex xs10 sm6 md8 mx-auto>
        <p class="display-1 font-weight-regular mt-3 mx-5 text-xs-center">
          See scores from all league matches
        </p>
      </v-flex>
      <v-flex xs8 sm6 md4 mx-auto>
        <img src="../../assets/undraw_fans.svg" alt="Game day" class="image" />
      </v-flex>
      <v-flex xs8 sm6 md4 mx-auto>
        <img
          src="../../assets/undraw_finish_line.svg"
          alt="Fans"
          class="image"
        />
      </v-flex>
      <v-flex xs10 sm6 md8 mx-auto>
        <p class="display-1 font-weight-regular mt-3 mx-5 text-xs-center">
          See who comes out on top
        </p>
      </v-flex>
      <v-flex xs10 sm6 md8 mx-auto>
        <p class="display-1 font-weight-regular mt-3 mx-5 text-xs-center">
          Celebrate your victory
        </p>
      </v-flex>
      <v-flex xs8 sm6 md4 mx-auto>
        <img
          src="../../assets/undraw_winners.svg"
          alt="Game day"
          class="image"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "LandingDetails"
};
</script>

<style scoped>
.image {
  width: 100%;
  height: auto;
}
</style>
